export function getPolicyLink(
  wixPolicyLink: string,
  editorxPolicyLink: string,
) {
  let policyLink = wixPolicyLink
  try {
    policyLink =
      location.hostname.indexOf('.editorx.com') > 0
        ? editorxPolicyLink
        : wixPolicyLink
  } catch (e) {
    // Linted this and had a blast!!
  }
  return policyLink
}
